import { render } from "./BaseTextArea.vue?vue&type=template&id=0eab2534"
import script from "./BaseTextArea.vue?vue&type=script&lang=js"
export * from "./BaseTextArea.vue?vue&type=script&lang=js"
script.render = render

export default script